<template>
  <section>
    <slot />
  </section>
</template>

<script>
export default {
  components: {},
  inject: ["globalNavigation"],
};
</script>
import
<style lang="scss" module>
@import "@mds/constants";
.mdc-global-navigation-group {
  margin-top: $mds-space-3-x;

  &:first-child {
    margin-top: unset;
  }

  &__heading {
    display: flex;
    align-items: center;
    margin-bottom: $mds-space-1-x;
  }

  &--collapsed {
    margin-top: unset;
  }
}
</style>
